import { useIntl } from 'react-intl';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import moment from 'moment';
import { OrderSummary } from './types';

interface ExpiredOrderAlertProps {
  order: Pick<OrderSummary, 'orderNumber' | 'decisionDeadline'>;
  consultantView?: boolean;
}

const ExpiredOrderAlert = ({
  order,
  consultantView = false,
}: ExpiredOrderAlertProps) => {
  const intl = useIntl();

  return (
    <Alert severity="warning">
      <AlertTitle>
        {intl.formatMessage({ id: 'ORDERS.EXPIRED.TITLE' })}
      </AlertTitle>
      {intl.formatMessage(
        {
          id: consultantView
            ? 'MY_ORDERS.EXPIRED_MESSAGE'
            : 'ORDERS.EXPIRED.MANAGER_MESSAGE',
        },
        {
          number: order.orderNumber,
          date: moment(order.decisionDeadline).format('DD/MM/YYYY'),
        },
      )}
    </Alert>
  );
};

export default ExpiredOrderAlert;
